import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class subTasksTemplatesTableCtrl implements IController {

  templates: any;
  canEdit: boolean;
  canEditSequenceIndex: boolean;
  canDelete: boolean;
  templateSettingsMap: any;
  isShowEnabledPurpose: boolean;
  onEdit: Function;
  onEditSequenceIndex: Function;
  onDelete: Function;
  onSettingsValueChange: Function;
  onChangeEnabledPurposes: Function;

  public usedSequenceIndexList: number[];

  /* @ngInject */
  constructor() {
  }

  $onChanges(changes) {
    if (changes.templateSettingsMap) {
      this.usedSequenceIndexList = [];
      _.forOwn(this.templateSettingsMap, (v, k) => {
        if (v?.value?.sequenceIndex) {
          this.usedSequenceIndexList.push(v.value.sequenceIndex);
        }
      })
    }

  };

}

angular
  .module('bringoz.admin.sub-tasks')
  .component('subTasksTemplatesTable', {
    require: {
      form: '^form'
    },
    bindings: {
      templates: '<',
      canEdit: '<?',
      canEditSequenceIndex: '<?',
      canDelete: '<?',
      templateSettingsMap: '<?',
      isShowEnabledPurpose: '<?',
      onEdit: '&',
      onEditSequenceIndex: '&',
      onDelete: '&',
      onSettingsValueChange: '&',
      onChangeEnabledPurposes: '&'
    },
    template: require('./sub-tasks-templates-table.html').default,
    controller: subTasksTemplatesTableCtrl
  });
